export default __webpack_public_path__ + "static/media/app-in-iphone-with-reflection.7dd563a4.png";